"use client";
import { FunctionComponent, useRef, useState } from "react";
import { LinkIcon } from "@heroicons/react/24/outline";
import { cn } from "../../utils/cn";

export interface CopyLinkProps {
  href: string;
}

/**
 * @
 */
export const CopyLink: FunctionComponent<CopyLinkProps> = ({ href }) => {
  const [copied, setCopied] = useState(false);
  const timeoutIdRef = useRef<any>(null);
  async function onClick() {
    await navigator.clipboard.writeText(href);
    setCopied(true);
    clearTimeout(timeoutIdRef.current);
    timeoutIdRef.current = setTimeout(() => setCopied(false), 1000);
  }

  return (
    <div className="flex h-14 w-fit items-center rounded-lg border border-gray-300 text-gray-400">
      <div className="border-r p-3">
        <LinkIcon className="h-5 w-5" />
      </div>
      <div className="px-4">
        <span className="text-base">{href}</span>
      </div>
      <div className="h-full p-1">
        <button
          onClick={onClick}
          className={cn(
            "h-full rounded-lg px-8 py-3 text-white",
            copied
              ? "bg-green-500 hover:bg-green-600"
              : "bg-blue-500 hover:bg-blue-600",
          )}
        >
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
};
